import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { FormGroup, AbstractControl, FormArray, ReactiveFormsModule } from '@angular/forms';
import { PartyService } from '../Services/party.service';
import { IWorker } from '../Interfaces/worker';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgIf, NgFor } from '@angular/common';
import { MatDivider } from '@angular/material/divider';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'app-roster-confirmation',
    templateUrl: './roster-confirmation.component.html',
    styleUrls: ['./roster-confirmation.component.scss'],
    imports: [NgIf, ReactiveFormsModule, MatDivider, NgFor, MatFormField, MatSelect, MatOption]
})
export class RosterConfirmationComponent implements OnInit, AfterViewInit {
  @Input() group: FormGroup;
  @Input() meetingID: string;
  @ViewChild(MatSelect) select: MatSelect;
  public countOfMatched: number;
  private existingRecords: Array<IWorker> = [];
  public selectedValue : Array<String> =[];
  public noRecordsAddedOrUpdated: Boolean = false;
  public workersAddedOnly: Boolean = false;
  public alreadyRegisteredAttendeeIds: Array<number> = [];
  public isProcessing = false;

  matchedRecords: Array<any> = [];

  constructor(private partyService: PartyService) { }

  filterRoster(group: FormGroup, status: string) {
    let check = group.get("status").value === status && group.get("isSelected").value;

    return check;
  }

  get rosterArray(): FormArray {
    return this.group.get("Roster") as FormArray;
  }

  get newContactArray(): FormArray {
    return this.group.get("NewContacts") as FormArray;
  }

  set newContactArray(array: FormArray) {
    this.group.setControl("NewContacts", array);
  }

  ngOnInit(): void {
    this.alreadyRegisteredAttendeeIds = [];
    let workerList = this.group.value.Roster as Array<any>;
    let newContactsList = this.group.value.NewContacts as Array<any>;
    if (!!this.meetingID && workerList.length === 0 && newContactsList.length === 0){
    // if (workerList.length === 0){
      this.noRecordsAddedOrUpdated = true;
      console.log(`no workers selected or added, nothing to match, proceed with updating meeting`);
    } else {
      console.log(workerList);
      console.log(typeof(workerList));
      this.countOfMatched = workerList.filter(function (x) {
        return x.isSelected && x.status === "M";
      }).length;

      if (workerList.length === 0 && newContactsList.length > 0){
        this.workersAddedOnly = true;
        console.log(`new workers added`);
      }

      let meeting = this.group.value.Meeting;
      if (this.matchedRecords.length > 0)
        return;
      this.newContactArray.controls.filter(function (element) {
        return element.get("isSelected").value;
      }).forEach((element, index) => {
        if ((element.get("id").value === "" && element.get("status").value === "") || (element.get("status").value === "L")) {
          this.matchedRecords.push({
            newRecord: element,
            parentArrayIndex: index,
            matches: null
          });
          

          this.SetMatches(element, index, meeting).then((data)=>
            {
            console.log(data);
              console.log(this.selectedValue);
              //this.updateSelectedValues();
              const selectedId = this.selectedValue[index];
              return this.SelectMatch({value: selectedId}, index);

            }
          )
        }
      });
      console.log(this.matchedRecords);
    }
  
  }

  ngAfterViewInit(): void {
    // AfterViewInit lifecycle hook
    // if (this.select) {
    //   this.selectedValue = this.select.value;
    //   console.log('Selected value:', this.selectedValue);
    // }
  }

  async SetMatches(worker: AbstractControl, index: number, meeting: any): Promise<any> {
    let definedWorker: IWorker;
    let resultSet: IWorker[] = [];

    try {
      this.isProcessing = true;
      const records = await this.partyService.CheckForExistingRecords("$/_i4u_/Core/Contact Layouts/Organisations/Meeting Roster/Attendance_Roll_DupCheck", meeting, worker.value).toPromise();
      this.isProcessing = false;

      records.Items.$values.forEach((element,index) => {
 
        definedWorker = {
          id: element.Properties.$values.find(y=>y.Name ==="iMIS ID").Value,
          isSelected: index === 0,
          email: element.Properties.$values.find(y=>y.Name ==="Email").Value,
          memberType: element.Properties.$values.find(s => s.Name === "MemberType").Value,
          firstName: element.Properties.$values.find(y=>y.Name ==="FirstName").Value,
          middleName: element.Properties.$values.find(y=>y.Name ==="MiddleName").Value,
          lastName: element.Properties.$values.find(y=>y.Name ==="LastName").Value,
          mobilePhone: element.Properties.$values.find(y=>y.Name ==="TollFree").Value,
          matchedCompany: element.Properties.$values.find(y=>y.Name ==="Company").Value,
          matchedCompanyId: element.Properties.$values.find(y=>y.Name ==="Company").Value,
          workPhone: element.Properties.$values.find(y=>y.Name ==="WorkPhone").Value,
          status: '',
          matchedRanking: 0
 
        };
        this.CalcRanking(definedWorker, worker, index);
        if (definedWorker.matchedRanking >= 40)
          resultSet.push(definedWorker);
 
      });
 
      if (resultSet.length > 0) {
        let matchedItem = this.matchedRecords.find(x => x.parentArrayIndex === index);
        matchedItem.matches = resultSet.map(x => x);
       
        // Ensure selectedValue is set properly
        this.selectedValue[index] = this.DefaultMatch(matchedItem);
        console.log("Default selected value set:", this.selectedValue[index]);
        
        // Only set default if the worker is NOT a new attendee (has non-empty ID)
        // const isNewUser = !worker.get("id").value || worker.get("id").value === "";

        // if (!isNewUser) {
        //   const defaultId = this.DefaultMatch(matchedItem);
        //   this.selectedValue[index] = defaultId;

        //   // Call SelectMatch with valid event shape
        //   this.SelectMatch({ value: [defaultId] }, index);
        // } else {
        //   this.selectedValue[index] = "";
        // }
      }

      return this.selectedValue;
     
      //resultSet = null;
    } catch (error) {
      console.error("Error in SetMatches",error)
      throw error;
    }
  }
  

  GetMatchesOld(worker: AbstractControl, index: number): Array<any> {
    let internalArray = Array.from(this.existingRecords);
    internalArray.forEach(record =>
      this.CalcRanking(record, worker, index)
    );

    return internalArray.filter((item) => item.matchedRanking >= 40).sort(x => x.matchedRanking).reverse();

  }
  CalcRanking(existing: IWorker, worker: AbstractControl, index: number) {

    let keys = ["firstName", "lastName", "email", "mobilePhone"];
    keys.forEach(key => {
      if (worker.get("firstName").value === "Sample") {
        console.log(worker.value);
        console.log(existing);
      }
      existing.recordLink = index;
      if (worker.get("id").value !== undefined && worker.get("status").value === "L")
        existing.isSelected = true;
      if (worker.get(key).value !== "" && existing[key] !== "")
        existing.matchedRanking += 25 * (worker.get(key).value.toLowerCase() === existing[key].toLowerCase() ? 1 : 0);
    });


  }
  DefaultMatch(item: any) {
    if (item === null || item.matches === null || item.matches.length === 0)
      return "";
    else if (item.matches[0].isSelected)
       return item.matches[0].id;
    return item.matches[0].id;

  }
  public SelectMatch(event: any, index: number) {
    // console.log(event.value);
    console.log("SelectMatch is called");
  
    let defaultValue: any;
  
    if (this.selectedValue[index] != null && this.selectedValue[index] != undefined && this.selectedValue[index] != "") {
      console.log("Using selectedValue", this.selectedValue); 
      defaultValue = this.selectedValue[index];
    }
    else if (event.value && event.value.length > 0) {
      console.log("Using event value", event.value); 
      defaultValue = event.value[0]; // Use the first value from event if available
    } else {
      // Fallback to default match
      console.log("Fallback to DefaultMatch", event.value, "at index", index);
      defaultValue = this.DefaultMatch(this.matchedRecords.find(x => x.parentArrayIndex === index));
    }
  
    console.log("Final defaultValue:", defaultValue);
  
    if (defaultValue !== "" && defaultValue !== null && defaultValue !== undefined) {
      let match = this.newContactArray.controls[index];
      match.get("id").setValue(defaultValue);
      match.get("status").setValue("L");
      // console.log(this.group);
    } else {
      let match = this.newContactArray.controls[index];
      console.log(match);
      match.get("status").setValue("");
    }

    // Check if defaultValue is already in the registered attendees list
    if (!!this.meetingID && defaultValue) {
      this.isProcessing = true;
      try {
      this.isProcessing = true;
       this.partyService.CheckAlreadyRegisteredAttendees(this.meetingID).then((registeredIds: string[]) => {
          if (registeredIds.includes(defaultValue.toString())) {
            this.alreadyRegisteredAttendeeIds.push(defaultValue);

            // alert(`Warning: The selected attendee (ID: ${defaultValue}) is already registered for this meeting.`);
          }
        }).finally(() => {
          this.isProcessing = false;
        });
      } catch (error) {
        this.isProcessing = false;
        console.error("Error checking already registered attendees:", error);
      }
    }
  }

  isAttendeeAlreadyRegistered(item): boolean {
    if (this.alreadyRegisteredAttendeeIds.includes(item.newRecord.get("id").value)){
      return true;
    } else {
      return false;
    }
  }
}  
